<template lang="pug">
  .skeleton-item-welfare(
    :class="{ [className]: className }"
  )
</template>

<script>
export default {
  name: 'Demo',
  props: {
    className: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less" scoped>
.skeleton-item-welfare {
  position: relative;
  overflow: hidden;
  background-color: #f1f7fa;
  width: 1.19rem;
  height: 0.22rem;
  border-radius: 0.08rem;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
      linear-gradient(
        90deg,
        transparent 0%,
        #e7f1f6 50%,
        transparent 100%
      );
    animation: shimmer 1.5s infinite;
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }

  100% {
    transform: translateX(100%);
  }
}
</style>
